<template>
<section>
  <div class="container">
    <b-field :addons="false">
      <b-field expanded label="Email" :type="{ 'is-danger': hasError }" :message="{ 'Please provide a valid email address': hasError }">
        <b-input ref="myInput" placeholder="Email" v-model="username" @keyup.native="enterClick($event)"></b-input>
      </b-field>
      <b-field expanded label="Password" :type="{ 'is-danger': hasError }" :message="{ 'Please input a correct password': hasError }">
        <b-input placeholder="Password" type="password" v-model="password" password-reveal @keyup.native="enterClick($event)"></b-input>
      </b-field>
    </b-field>
    <div class="columns">
      <div class="column is-4"></div>
      <div class="column is-4">
        <b-button id="login" style="background-color:#3e8ed0; color:white; font-weight:600" expanded @click="login">LOGIN</b-button>
      </div>
      <div class="column is-4"></div>
    </div>
    <p @click="test" style="text-align: center; font-size: small; cursor: pointer; color: rgb(132, 174, 209)">Forgot password?</p>
  </div>
</section>
</template>

<script>
import * as firebase from 'firebase'
// import axios from 'axios'

export default {
  name: 'Login',
  props: [],
  data: () => {
    return {
      username: '',
      password: '',
      hasError: false,
      ipInfo: null
    }
  },
  methods: {
    test () {
      let text = 'If you have forgotten your password, please contact our team at <b>support@neoslide.mk</b>.'
      this.$buefy.dialog.alert(text)
    },
    login () {
      firebase.auth().signInWithEmailAndPassword(this.username, this.password)
        .then((user) => {
          this.globalLogger(user.user.uid, 'USER ID')
          let database = this.$store.state.database
          if (!this.getNotMigrated().includes(user.user.uid)) {
            database.ref('/neoslide/users/' + user.user.uid).on('value', (snapshot) => {
              if (snapshot.val().role === 'device') {
                firebase.auth().signOut()
                this.showLoginError('Invalid login', 'This account does not have login privileges.')
              } else if (snapshot.val().status === 2) {
                firebase.auth().signOut()
                this.showLoginError('Account suspended', 'You cannot log in with this account as it has been suspended.')
              } else if (snapshot.val().status === 3) {
                firebase.auth().signOut()
                this.showLoginError('Account terminated', 'You cannot log in with this account as it has been terminated.')
              } else {
                this.setupTimers()
                this.$emit('login-clicked')
                this.$router.push({ name: 'Playlists' })
              }
            })
          } else {
            database.ref('/users/' + user.user.uid).on('value', (snapshot) => {
              if (snapshot.val().status === 2) {
                firebase.auth().signOut()
                this.showLoginError('Account suspended', 'You cannot log in with this account as it has been suspended.')
              } else if (snapshot.val().status === 3) {
                firebase.auth().signOut()
                this.showLoginError('Account terminated', 'You cannot log in with this account as it has been terminated.')
              } else {
                this.setupTimers()
                this.$emit('login-clicked')
                this.$router.push({ name: 'Playlists' })
              }
            })
          }
        })
        .catch(error => {
          this.globalLogger(error.message, 'empty')
          this.hasError = true
        })
      this.globalLogger('login clicked')
    },
    enterClick (event) {
      if (event.keyCode === 13) {
        event.preventDefault()
        document.getElementById('login').click()
      }
    },
    showLoginError (title, mess) {
      this.$buefy.dialog.alert({
        title: title,
        message: mess,
        type: 'is-danger',
        hasIcon: true,
        icon: 'times-circle',
        iconPack: 'fa',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/login/Login.vue